module.exports = __webpack_public_path__ + "static/media/story-3.46731461.jpg";